<!--直播课-->
<template>
  <div class="el-LiveClass">
    <el-row class="page_content">
      <h1 class="head_title">直播课</h1>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="grade" header-align="center" align="center" label="年级">
        </el-table-column>
        <el-table-column prop="liveName" header-align="center" align="center" label="直播名称">
        </el-table-column>
        <el-table-column prop="teachername" header-align="center" align="center" label="直播教师" width="180">
        </el-table-column>
        <el-table-column prop="startTime" header-align="center" align="center" label="直播开始时间" width="180">
        </el-table-column>
        <el-table-column prop="endTime" header-align="center" align="center" label="直播结束时间" width="180">
        </el-table-column>
        <el-table-column prop="currentstate" header-align="center" align="center" label="状态" width="180">
          <template slot-scope="scope">
            <el-link :underline="false" v-if="scope.row.currentstate == '直播中'" type="danger">{{ scope.row.currentstate
              }}</el-link>
            <el-link :underline="false" v-if="scope.row.currentstate == '未开始'" type="primary">{{ scope.row.currentstate
              }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="" header-align="center" align="center" label="操作" width="180">
          <template slot-scope="scope">
            <el-link :underline="false" type="primary" @click="getliveUrl(scope.row.liveUrl)">观看直播</el-link>
            <el-link :underline="false" type="primary" @click="openVisible(scope.row.id)"
              v-if="scope.row.workId == null || scope.row.workId == ''">上传作业</el-link>
            <el-link :underline="false" type="warning" @click="openVisible(scope.row.id, scope.row.workId)"
              v-else>重新上传</el-link>
          </template>
        </el-table-column>
      </el-table>
      <h1 class="head_title" style="margin-top:20px;">直播回放</h1>
      <el-table :data="playbackData" border style="width: 100%">
        <el-table-column prop="grade" header-align="center" align="center" label="年级">
        </el-table-column>
        <el-table-column prop="liveName" header-align="center" align="center" label="直播名称">
        </el-table-column>
        <el-table-column prop="teachername" header-align="center" align="center" label="直播教师" width="180">
        </el-table-column>
        <el-table-column prop="startTime" header-align="center" align="center" label="直播开始时间" width="180">
        </el-table-column>
        <el-table-column prop="endTime" header-align="center" align="center" label="直播结束时间" width="180">
        </el-table-column>
        <el-table-column prop="currentstate" header-align="center" align="center" label="状态" width="180">
          <template slot-scope="scope">
            <el-link :underline="false" type="info">{{ scope.row.currentstate }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="" header-align="center" align="center" label="操作" width="180">
          <template slot-scope="scope">
            <el-link :underline="false" type="primary" @click="getliveUrl(scope.row.liveUrl)">观看回放</el-link>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-dialog title="上传作业" :visible.sync="visible" width="800px">
      <div style="text-align: center;padding-bottom: 50px;">
        <el-form ref="form" :model="form" label-width="100px" class="replyform">
          <el-form-item label="作业:">
            <span style="float:left;margin-right:20px;">
              <el-upload class="avatar-uploader" :action="uploadUrl" :headers="headers" :show-file-list="false"
                :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                <span>{{ form.fileName }}</span>
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </span>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="save">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getQueryVariable, openWithRoleTag, getCookieForRoleTag } from "../../common/ulit";

export default {
  name: "LiveClass",
  data() {
    return {
      uploadUrl: this.$baseUrl + "/api/file/update.do", //请求接口
      headers: { token: getCookieForRoleTag(), "_role_tag": getCookieForRoleTag() ? getCookieForRoleTag().split(".")[getCookieForRoleTag().split(".").length - 1] : null }, //请求头
      visible: false,
      disabledset: false,
      tableData: [],
      studentInfo: {},
      playbackData: [],
      form: {
        id: '',
        fileName: '',
        url: '',
        liveId: '',
        studentId: '',
      },
      //年级
      //函授站
      //专业
      //班级
      //课程
    };
  },
  created() {
    this.studentInfo = JSON.parse(sessionStorage.getItem(this.$getStudentInfoKeyForRoleTag()));
    console.info(this.studentInfo);
    this.getLivePlanList();
  },
  methods: {
    getliveUrl(url) {
      this.$router.push({ name: 'LiveCourse', params: { url: url } });
      //openWithRoleTag(url);
    },
    openVisible(liveId, workId) {
      this.form.liveId = liveId;
      this.form.id = workId;
      this.form.studentId = this.studentInfo.studentId;
      this.visible = true;
    },
    handleAvatarSuccess(res, tag) {
      if (res.code == 0) {
        console.log('res', res);
        this.form.fileName = res.data.title
        this.form.url = res.data.url
      }
    },
    beforeAvatarUpload(file) {

    },
    save() {
      if (this.form.url == '' || this.form.url == null || this.form.url == undefined) {
        this.$message({
          message: '请先上传作业',
          type: 'warning'
        });
        return;
      }
      var postUrl = "";
      if (this.form.id != '' && this.form.id != null && this.form.id != undefined) {
        //编辑
        postUrl = "user/updateLiveWork";
      } else {
        //添加
        postUrl = "user/saveLiveWork";
      }
      this.$store.dispatch(postUrl, this.form).then((ret) => {
        if (ret.code === 0 || ret.code === '0') {
          this.$message({
            message: '重新上传成功',
            type: 'success'
          });
          this.visible = false;
          this.form = {
            id: '',
            fileName: '',
            url: '',
            liveId: '',
            studentId: '',
          };
          this.getLivePlanList();
        } else {
          this.$message({
            message: ret.msg,
            type: 'warning'
          });
        }
      })
    },


    getLivePlanList() { //获取直播计划List
      this.$store.dispatch("user/getLivePlanList", { studentId: this.studentInfo.studentId, currentstate: 1 }).then((ret) => {
        if (ret.code === 0 || ret.code === '0') {
          this.tableData = ret.data;
        } else {
          this.$message({
            message: ret.msg,
            type: 'warning'
          });
        }
      })

      this.$store.dispatch("user/getLivePlanList", { studentId: this.studentInfo.studentId, currentstate: 2 }).then((ret) => {
        if (ret.code === 0 || ret.code === '0') {
          this.playbackData = ret.data;
        } else {
          this.$message({
            message: ret.msg,
            type: 'warning'
          });
        }
      })

    }
  }
};
</script>
<style lang="less">
@import '../../styles/base.less';

.el-LiveClass {
  .wd {
    color: @red;
  }

  .el-dialog__body {
    border-top: 1px solid #ebeef5;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/live/livePlan.vue